@if (summary) {
<ui-order-summary [summary]="summary"></ui-order-summary>
}

